module.exports = {"341702001":"池阳街道","341702002":"秋浦街道","341702003":"里山街道","341702004":"江口街道","341702005":"马衙街道","341702006":"墩上街道","341702007":"梅龙街道","341702008":"秋江街道","341702009":"杏花村街道","341702010":"清风街道","341702011":"清溪街道","341702100":"殷汇镇","341702101":"牛头山镇","341702102":"涓桥镇","341702103":"梅街镇","341702104":"梅村镇","341702105":"唐田镇","341702106":"牌楼镇","341702107":"乌沙镇","341702108":"棠溪镇","341702400":"安徽池州高新技术产业开发区","341702401":"池州经济技术开发区","341702402":"平天湖风景区","341702404":"皖江江南新兴产业集中区","341702405":"池州承接产业转移集中示范园区","341702406":"池州市杏花村文化旅游区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341702.json
// module id = 1256
// module chunks = 0